import React, { Component } from 'react'
import Link, { push } from 'gatsby-link'
import styled from 'styled-components'
import Responsive from 'react-responsive'
import NavigationItem from '../components/navigation-item'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  padding-right: 3vw;
  padding-top: 1.5vw;
  width: 100vw;
  > div.lang {
    margin-left: 10vw;
  }
`
const Lang = styled(NavigationItem)``

class Navigation extends Component {
  state = {
    items: [
      {
        label: 'Projetos',
        label_en: 'Projects',
        link: '/projetos',
        marked: false
      },
      {
        label: 'Escritório',
        label_en: 'Studio',
        link: '/escritorio',
        marked: false
      },
      { label: 'Memória', label_en: 'Memory', link: '/memoria', marked: false },
      { label: 'Acervo', label_en: 'Archive', link: '/acervo', marked: false },
      {
        label: 'Contato',
        label_en: 'Contact',
        link: '/contato',
        marked: false
      }
      // { label: 'Mídia', link: '/media', marked: false },
    ],
    pathname: '',
    language: ''
  }

  componentDidMount () {
    if (window) {
      const { pathname } = window.location
      let items = this.state.items
      items.map(item => {
        item.marked = (item.link == '/projetos' && pathname.indexOf('/projeto') !== -1) || item.link === pathname
      })
      this.setState({ items, pathname: pathname })

      if (window.location.search) {
        this.setState({ language: window.location.search })
      }
    }
  }

  componentWillUpdate () {
    if (window) {
      const { pathname } = window.location
      if (this.state.pathname !== pathname) {
        let items = this.state.items
        items.map(item => {
          item.marked = (item.link == '/projetos' && pathname.indexOf('/projeto') !== -1) || item.link === pathname
        })
        this.setState({ items, pathname: pathname })
      }
    }
  }

  _change = lang => {
    window.location.href = lang == 'en' ? `${window.location.pathname}?lang=en` : window.location.pathname
  }

  _navigate = (uri, index) => {
    let items = this.state.items
    items.map((item, itemIndex) => {
      item.marked = itemIndex === index
    })
    this.setState({ items })
    push(uri)
  }

  render () {
    const { items } = this.state
    return (
      <Wrapper>
        {items.map((item, index) => (
          <NavigationItem
            key={index}
            label={this.state.language === '?lang=en' ? item.label_en : item.label}
            marked={item.marked}
            tone={this.props.tone}
            onClick={() => this._navigate(`${item.link}${this.state.language}`, index)}
          />
        ))}
        <div style={{ width: `5vw`, height: `1vw` }} />

        <Lang label='pt' marked={this.state.language === ''} tone={this.props.tone} style={{ marginLeft: `10vw` }} onClick={() => this._change('pt')} />
        <Lang label='en' marked={this.state.language === '?lang=en'} tone={this.props.tone} onClick={() => this._change('en')} />
      </Wrapper>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation.js